function isFileListLike(value: object): value is { length: number; item: (...args: unknown[]) => unknown } {
    const fileList = value as {
        length?: unknown;
        item?: unknown;
    };

    return typeof fileList.length === 'number' && typeof fileList.item === 'function';
}

function isFileLike(value: object): value is { name: string; size: number } {
    const file = value as {
        name?: unknown;
        size?: unknown;
        lastModified?: unknown;
        type?: unknown;
    };

    return typeof file.name === 'string' &&
        typeof file.size === 'number' &&
        (typeof file.lastModified === 'number' || typeof file.type === 'string');
}

export function hasRequiredValue(value: unknown): boolean {
    if (Array.isArray(value)) {
        return value.some((item) => hasRequiredValue(item));
    }

    if (value === null || value === undefined || value === '') {
        return false;
    }

    if (typeof value === 'object') {
        if (isFileListLike(value)) {
            return value.length > 0;
        }

        if (isFileLike(value)) {
            return true;
        }

        const objectValue = value as Record<string, unknown>;
        const keys = Object.keys(objectValue);
        if (keys.length === 0) {
            return false;
        }

        return keys.some((key) => hasRequiredValue(objectValue[key]));
    }

    return true;
}
